import React from "react";
import ReactDOM from "react-dom/client";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "./index.css";
import { App } from "./App";
import {
  Characters,
  Planet,
  Trend,
  Tiers,
  Cryptos,
  MintPage,
  UniswapHistory,
  DashboardPage,
  AirdropPage,
  Wallet,
} from "./Pages";
import { SnackbarProvider } from "notistack";
import reportWebVitals from "./reportWebVitals";
import { QueryClient, QueryClientProvider } from "react-query";
import {
  QueryClientProvider as WalletQueryProvider,
  QueryClient as WalletQueryClient,
} from "@tanstack/react-query";
import { AuthProvider, LoginModal } from "./Auth";
import "@rainbow-me/rainbowkit/styles.css";
import { getDefaultConfig, RainbowKitProvider } from "@rainbow-me/rainbowkit";
import { Token } from "@mui/icons-material";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

const theme = createTheme({
  typography: {
    fontFamily: "Rubik, Arial, sans-serif",
  },
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

const queryWalletClient = new WalletQueryClient();

root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <LoginModal />
          {/* <WalletQueryProvider client={queryWalletClient}>
            <RainbowKitProvider modalSize="compact"> */}
          <SnackbarProvider maxSnack={2}>
            <Router>
              <Routes>
                {/* <Route path="/airdrop" element={<AirdropPage />} />
                    <Route path="/dashboard" element={<DashboardPage />} /> */}
                <Route path="/subgraph" element={<UniswapHistory />} />
                <Route path="/nova" element={<MintPage />} />
                <Route path="/universe" element={<Tiers />} />
                <Route path="/orbit" element={<Cryptos />} />
                <Route path="/planet" element={<Planet />} />
                <Route path="/popular" element={<Trend />} />
                <Route path="/character/:name" element={<Characters />} />
                <Route path="/" element={<App />} />
              </Routes>
            </Router>
          </SnackbarProvider>
          {/* </RainbowKitProvider>
          </WalletQueryProvider> */}
        </AuthProvider>
      </QueryClientProvider>
    </ThemeProvider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
